import React from 'react';
import { ToggleButtonGroup, ToggleButton, Box, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';

export type OperationMode = 'upsert' | 'delete';

interface OperationModeSelectorProps {
  mode: OperationMode;
  onChange: (mode: OperationMode) => void;
  disabled?: boolean;
}

const OperationModeSelector: React.FC<OperationModeSelectorProps> = ({ mode, onChange, disabled }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Typography variant="body2" color="textSecondary">
        Operacion:
      </Typography>
      <ToggleButtonGroup
        value={mode}
        exclusive
        size="small"
        disabled={disabled}
        onChange={(_, newMode) => {
          if (newMode !== null) onChange(newMode as OperationMode);
        }}
      >
        <ToggleButton value="upsert">
          <AddCircleIcon fontSize="small" sx={{ mr: 0.5 }} />
          Crear / Actualizar
        </ToggleButton>
        <ToggleButton value="delete" color="error">
          <DeleteIcon fontSize="small" sx={{ mr: 0.5 }} />
          Eliminar
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default OperationModeSelector;
